// Centralized validation for Project Objective edit flow

function getByPath(obj, path) {
  if (!obj || !path) return undefined;
  const parts = path.split(".");
  let cur = obj;
  for (let i = 0; i < parts.length; i += 1) {
    const key = parts[i];
    if (cur == null || typeof cur !== "object") return undefined;
    cur = cur[key];
  }
  return cur;
}

export function validateProjectObjectiveEditForm(current, isCreate) {
  const errs = {};
  if (!current || typeof current !== "object") return errs;
  const productivityTargetType = getByPath(
    current,
    "productivity.productivityTargetType",
  );
  const includeInCountryList = getByPath(
    current,
    "requirements.includeInCountryList",
  );
  const isUnitPerhour = productivityTargetType === "Units & units/hour";
  // Field label mapping
  const fieldLabels = {
    "info.name": "Project Objective Name",
    "requirements.workType": "Work Type",
    "info.dateStart": "Date Start",
    "info.dateEnd": "Date End",
    "diversity.minimumContributors": "Minimum Contributors",
    "productivity.productivityTargetType": "Productivity Target Type",
    "targets.productionPaymentThreshold": "Production Payment Threshold",
    "targets.qualityPaymentThreshold": "Quality Payment Threshold",
    "requirements.listOfCountries": "List of Countries",
  };

  // Required fields
  const required = [
    "requirements.workType",
    ...(isCreate ? ["productivity.productivityTargetType"] : []),
    ...(isUnitPerhour
      ? [
          "targets.productionPaymentThreshold",
          "targets.qualityPaymentThreshold",
        ]
      : []),
    ...(includeInCountryList ? ["requirements.listOfCountries"] : []),
  ].filter(Boolean);
  required.forEach((path) => {
    const v = getByPath(current, path);
    // Check for undefined, null, empty string, or whitespace-only string
    // Also check for falsy values that might be used as "not selected"
    const isEmpty =
      v === undefined ||
      v === null ||
      v === "" ||
      (typeof v === "string" && v.trim() === "") ||
      (typeof v === "number" && isNaN(v));
    if (isEmpty) {
      errs[path] = `${fieldLabels[path]}: This field is required`;
    }
  });

  // Date range: End >= Start if both provided
  const start = getByPath(current, "info.dateStart");
  const end = getByPath(current, "info.dateEnd");
  if (start && end) {
    const sd = new Date(start);
    const ed = new Date(end);
    if (!isNaN(sd) && !isNaN(ed) && ed < sd) {
      errs["info.dateEnd"] = "End date must be on/after Start date";
    }
  }

  // Minimum Contributors: integer if provided
  const minContrib = getByPath(current, "diversity.minimumContributors");
  if (
    minContrib !== undefined &&
    minContrib !== null &&
    String(minContrib) !== ""
  ) {
    const n = Number(minContrib);
    if (!Number.isInteger(n)) {
      errs["diversity.minimumContributors"] =
        `${fieldLabels["diversity.minimumContributors"]}: Must be an integer`;
    }
  }

  // Country or Language: At least one must be filled
  const country = getByPath(current, "requirements.country");
  const language = getByPath(current, "requirements.language");

  const excludeStates = getByPath(current, "requirements.excludeStates");
  const currentlyResidingUsState = getByPath(
    current,
    "requirements.currentlyResidingUsState",
  );
  const listOfCountries = getByPath(current, "requirements.listOfCountries");
  const countryIsEmpty =
    country === undefined ||
    country === null ||
    country === "" ||
    (typeof country === "string" && country.trim() === "");

  const languageIsEmpty =
    language === undefined ||
    language === null ||
    language === "" ||
    (typeof language === "string" && language.trim() === "");

  const currentlyResidingUsStateIsEmpty =
    Array.isArray(currentlyResidingUsState) &&
    currentlyResidingUsState.length === 0;
  const listOfCountriesIsEmpty =
    Array.isArray(listOfCountries) && listOfCountries.length === 0;

  if (countryIsEmpty && languageIsEmpty) {
    errs["requirements.country"] = "Either Country or Language must be filled";
    errs["requirements.language"] = "Either Country or Language must be filled";
  }
  if (excludeStates) {
    if (currentlyResidingUsStateIsEmpty) {
      errs["requirements.currentlyResidingUsState"] =
        "Atleast one State should be filled when excluding states";
    }
  }
  if (includeInCountryList) {
    if (listOfCountriesIsEmpty) {
      errs["requirements.listOfCountries"] =
        "Atleast one Country should be selected when including countries";
    }
  }

  // Funnel Total: Should be exact 100

  const funnelA = getByPath(current, "funnelSplits.funnelA");
  const funnelB = getByPath(current, "funnelSplits.funnelB");
  const funnelC = getByPath(current, "funnelSplits.funnelC");
  const funnelD = getByPath(current, "funnelSplits.funnelD");
  const funnelE = getByPath(current, "funnelSplits.funnelE");

  const sum =
    parseInt(funnelA) +
    parseInt(funnelB) +
    parseInt(funnelC) +
    parseInt(funnelD) +
    parseInt(funnelE);

  if (sum != 100) {
    errs["funnel.funnelAPercentage"] = "Total of all Funnels must be 100";
  }

  //Production and Quality Payment Threshold are required Fields whose value must not be over 100

  const productionPaymentThreshold = getByPath(
    current,
    "targets.productionPaymentThreshold",
  );
  const qualityPaymentThreshold = getByPath(
    current,
    "targets.qualityPaymentThreshold",
  );

  if (productionPaymentThreshold > 100)
    errs["targets.productionPaymentThreshold"] =
      "Production Payment Threshold value cannot be Greater than 100";
  if (qualityPaymentThreshold > 100)
    errs["targets.qualityPaymentThreshold"] =
      "Quality Payment Threshold value cannot be Greater than 100";
  return errs;
}
